import React, { useState } from 'react';
import { Row, Col, Button, Container, FormInput, FormSelect, Badge } from 'shards-react';
import PageTitle from '../../../components/PageTitle';
import DocumentService from '../../../services/DocumentService';
import Translator from '../../../services/Translator';
import {
  Table,
  THead,
  Th,
  Td,
  TableRow,
  TableHeader,
  TableWrapper,
  H3
} from '@increase/typed-components';

const STATUS_OK = 'ok';
const STATUS_FAILED = 'failed';

const STATUS_OPTIONS = [
  { id: STATUS_OK, label: 'Ok' },
  { id: STATUS_FAILED, label: 'Fallado' }
];

export function SupportDocumentStatus() {
  const [documents, setDocuments] = useState('');
  const [processStatus, setProcessStatus] = useState(STATUS_OK);
  const [result, setResult] = useState();
  const [loading, setLoading] = useState(false);

  const handleDocumentsChange = (e) => {
    const value = e.target.value;
    const trimmed = value.replace(/\s/g, '');
    setDocuments(trimmed);
  };

  const handleStatusChange = (e) => {
    setProcessStatus(e.target.value);
  };

  const onSetStatus = () => {
    setResult(undefined);
    setLoading(true);
    const documentsArray = documents.split(',').filter((docId) => docId !== '');
    updateDocumentStatus(documentsArray);
  };

  const updateDocumentStatus = async (documentsArray) => {
    const documentService = await DocumentService();
    documentService
      .setDocumentStatus(documentsArray, processStatus)
      .then((data) => {
        setResult(data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const resultHasData = result && Array.isArray(result) && result.length > 0;
  const statusLabel =
    STATUS_OPTIONS.find((opt) => opt.id === processStatus)?.label || processStatus;

  return (
    <Container className="main-content-container px-4" fluid>
      <Row className="page-header py-4" noGutters>
        <PageTitle
          className="text-sm-left"
          sm="4"
          subtitle=""
          title="Cambiar Estado de Documentos"
        />
      </Row>
      <Row>
        <Col lg="6" sm="12" xs="12">
          <FormInput
            id="documents"
            onChange={handleDocumentsChange}
            placeholder="Documento(s) ID separados por coma"
            type="text"
            value={documents}
          />
        </Col>
        <Col lg="3" sm="4" xs="12">
          <FormSelect
            className="form-control"
            id="processStatus"
            name="processStatus"
            onChange={handleStatusChange}
            value={processStatus}
          >
            {STATUS_OPTIONS.map((option) => {
              return (
                <option key={option.id} value={option.id}>
                  {option.label}
                </option>
              );
            })}
          </FormSelect>
        </Col>
        <Col lg="3" sm="4" xs="12">
          <Button disabled={documents === '' || loading} onClick={onSetStatus}>
            {loading ? 'Procesando...' : 'Cambiar Estado'}
          </Button>
        </Col>
      </Row>
      {result && (
        <Row>
          <Col>
            <TableWrapper className="MarginTop20">
              <TableHeader>
                <H3>Resultado - Estado: {statusLabel}</H3>
              </TableHeader>
              <Table hasData={resultHasData} noDataMessage="No hay datos" zebra>
                <THead>
                  <tr>
                    <Th>Documento</Th>
                    <Th>Estado</Th>
                  </tr>
                </THead>
                <tbody>
                  {resultHasData &&
                    result.map((doc) => {
                      const statusIsNotFound = doc.status === 'not_found';
                      const statusDescription = Translator.documentStatusStatus(doc.status);
                      return (
                        <TableRow key={doc.id}>
                          <Td>{doc.id}</Td>
                          <Td>
                            <H3>
                              <Badge pill theme={statusIsNotFound ? 'danger' : 'success'}>
                                {statusDescription}
                              </Badge>
                            </H3>
                          </Td>
                        </TableRow>
                      );
                    })}
                </tbody>
              </Table>
            </TableWrapper>
          </Col>
        </Row>
      )}
      <Row className="mt-3">
        <Col>
          <p>Ingrese los scraped document IDs separados por coma y seleccione el estado deseado.</p>
        </Col>
      </Row>
    </Container>
  );
}
